import { Radio, RadioGroup } from "@headlessui/react";
import { Locale } from "date-fns";
import { ru } from "date-fns/locale/ru";
import { uz } from "date-fns/locale/uz";

import { JSX, useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";

import Button from "@/components/buttons/Button.tsx";
import PaymentList from "@/components/staff/payment/PaymentList.tsx";
import PaymentTable from "@/components/staff/payment/PaymentTable.tsx";

import { OrderType } from "@/api/user/user.types";
import "@/styles/datepicker.css";

const tabs = ["all", "top_up", "subscription"] as OrderType[];

const PaymentHistory = (): JSX.Element => {
  const { t } = useTranslation();
  const [tab, setTab] = useState<(typeof tabs)[number]>("all");
  // const [startDate, setStartDate] = useState<Date | null>(null);

  useEffect(() => {
    registerLocale("ru", ru as unknown as Locale);
    registerLocale("uz", uz as unknown as Locale);
  }, []);

  return (
    <section className={"staff-section-container mt-10 max-sm:mt-4"}>
      <div className={"flex items-center justify-between"}>
        <h2 className={"staff-section-title "}>{t("Payment.history")}</h2>
      </div>
      <div className={"space-y-6 max-sm:!mt-4"}>
        <RadioGroup
          value={tab}
          onChange={setTab}
          className={"hide-scrollbar flex gap-2 overflow-y-auto max-lg:-mx-4 max-lg:px-4"}
        >
          {tabs.map((item) => (
            <Radio key={item} value={item} as={"div"} className={"flex items-center gap-2"}>
              <Button
                type={"button"}
                color={item === tab ? "orange" : "black"}
                className={"text-nowrap max-sm:px-5 max-sm:py-3"}
              >
                {t(`Order.status.${item}`)}
              </Button>
            </Radio>
          ))}
        </RadioGroup>
        <PaymentTable orderType={tab} />
        <PaymentList orderType={tab} />
      </div>
    </section>
  );
};

export default PaymentHistory;
